import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      cacheDataVal: (state) => state.cacheRequest.cacheDataVal // 缓存数据
    })
  },
  methods: {
    /**
     *  缓存请求
     * @param type 快码类型
     * @param params 请求参数
     * @param listField 赋值的数据字段
     */
    cacheLookupRequest (type, params, listField) {
      if (!listField) return false;
      const cache = this.cacheDataVal[`${type}-${JSON.stringify(params)}`]
      if (cache && cache?.field && !this.isAllowTimeout(cache.effectTime, 30) && cache?.data?.length > 0) {
        this[listField] = cache.data // 引用缓存
      } else {
        // 重新请求
        this.getLookupListData(params).then(response => {
          if (response?.rows?.length > 0) {
            this.$store.commit('setRequestCache', {
              field: `${type}-${JSON.stringify(params)}`,
              data: response.rows,
              params: JSON.stringify(params),
              effectTime: Date.now() // 生效时间，必须
            })
            this[listField] = response.rows
          }
        })
      }
    },
    /**
     * 缓存是否超时
     * @param timestamp
     * @param allowTime
     * @returns {boolean}
     */
    isAllowTimeout(timestamp, allowTime = 30) {
      if (!timestamp) { return true }
      // 当前时间戳
      const currentTimestamp = Date.now();

      // 生效时间 = 设置的原始时间+允许缓存的时间(默认30分钟)
      const timeoutTimestamp = timestamp + allowTime * 60 * 1000;

      // 如果当前时间戳大于或等于生效时间的时间戳，则超时
      return currentTimestamp >= timeoutTimestamp;
    }
  }
}
